module.exports = __webpack_public_path__ + "img/C04TechCataphractS_ua.a74edada.webp";